import { Link } from "react-router-dom";
import SeriesNavigation from "../../components/SeriesNavigation";
import { leadershipMembers } from "../../data/navigationData";
import SEO from "../../components/SEO";

export default function AmosMeltzer() {
  const amosMeltzerSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": "Amos Meltzer",
    "jobTitle": "Corporate Development",
    "affiliation": {
      "@type": "Organization",
      "name": "Thrombio"
    },
    "url": "https://www.thrombio.com.au/leadership/amos-meltzer"
  };

  return (
    <div className="seniorManagementBg" style={{"--bg-opacity": "0.2"}}>
      <SEO
        title="Amos Meltzer - Corporate Development"
        description="Amos Meltzer is a seasoned life sciences executive, intellectual property lawyer, and technology commercialisation expert with over 25 years of experience."
        keywords={['Amos Meltzer', 'Corporate Development', 'Life Sciences', 'Intellectual Property', 'Biotechnology']}
        ogImage="/amosMeltzer.webp"
        schema={amosMeltzerSchema}
      />

      <div className="xl:page-width px-12 pt-[18px] pb-8">
        <nav className="flex flex-col md:flex-row md:items-center gap-1 md:gap-2 font-sans text-[2rem] font-normal leading-[2rem]" aria-label="Breadcrumb">
          <Link to="/leadership/senior-management" className="text-white hover:text-primary-red transition-colors">
            Senior Management
          </Link>
          <div className="flex items-center gap-2">
            <span className="text-white">/</span>
            <span className="text-[#5C95A4]">Amos Meltzer</span>
          </div>
        </nav>

        <div className="flex flex-col gap-2 md:gap-4 pt-24">
          <div className="text-[4.8rem] font-bold leading-[5.1rem] md:leading-[5.2rem] tracking-[.19rem] drop-shadow-[0_4px_8.9px_#000]">
            Amos Meltzer
          </div>
          <div className="font-syne font-bold text-left justify-start text-[#e0ffff] text-[2.9rem] font-medium leading-[3.6rem] tracking-[.096rem] [text-shadow:_2px_4px_5px_rgb(0_0_0_/_1.00)]">
            Corporate Development
          </div>
        </div>
      </div>

      <div className="pt-[50px] xl:pt-[90px] xl:pb-[80px] xl:page-width px-12">
        <div className="w-full">
          <div className="grid lg:grid-cols-12 gap-16 items-start">
            <div className="lg:col-span-3">
              <img 
                src="/amosMeltzer.webp" 
                alt="Amos Meltzer, Corporate Development: Expert in Life Sciences, Intellectual Property, and Technology Commercialisation" 
                className="w-full max-w-[300px] mx-auto md:max-w-[300px] md:mx-0"
                width={650} 
                height={650} 
              />
            </div>
            
            <div className="lg:col-span-8 flex flex-col">
              <div className="font-sans text-[2.1rem] leading-[3.1rem] tracking-[.042rem] text-white">
                Amos Meltzer (corporate development) is a seasoned life sciences executive, intellectual property lawyer, and technology commercialisation expert with over 25 years of experience in biotechnology, pharmaceuticals, and medical devices. He has held key leadership roles, including COO at Synchron, Non-Executive Director at Paradigm Biopharmaceuticals, and Chairman of Maverick Life Sciences.
Amos has successfully led clinical development, secured funding, and negotiated high-value commercial agreements for ASX and Nasdaq-listed companies. With a strong legal and business background, he has played a pivotal role in bringing innovative medical technologies to market, making him a trusted leader in the life sciences industry.
              </div>
            </div>
          </div>
        </div>
      </div>
      <SeriesNavigation 
        items={leadershipMembers} 
        currentSlug="amos-meltzer" 
        basePath="/leadership" 
      />
    </div>
  );
}